export default __webpack_public_path__ + "static/media/ic-animals-deer.ca5ee85c.svg";